$(function () {
    let $btn = $('[data-add-to-basket]');

    $btn.on('click', function (e) {
        e.preventDefault();
    })
})